import { CheckboxElement } from "react-hook-form-mui"

interface IProps {
  required?: boolean
}
interface IField {
  deduplicateByUser?: boolean
}

export const DedupByUserId = <T extends IField>({ required }: IProps) => {
  return (
    <CheckboxElement<IField>
      name="deduplicateByUser"
      label="Дедупликация получателей"
      helperText="Если один и тот же пользователь доступен в нескольких ботах, сообщение будет отправлено только в одного бота."
      required={required}
    />
  )
}
